<app-shared-drawer [title]="drawerTitle" className="action-plan-type-manage-drawer"
  contentClassName="action-plan-type-manage-drawer" [isOpen]="true" (onClose)="handleClose()">
  <form [formGroup]="form">
    <section>
      <div class="form-group">
        <label class="form-control-label"class="form-label" for="title">Título</label>
        <input type="text" class="form-control" id="title" formControlName="title"
          placeholder="Título do tipo de ocorrência" />
        <app-error-msg label="Título" [control]="form.controls['title']"></app-error-msg>
      </div>
    </section>

    <footer class="flex justify-content-end gap-2 mt-2">
      <button type="button" class="btn btn-light" (click)="handleClose()" [disabled]="isSubmitting">
        Cancelar
      </button>
      <button type="button" class="btn btn-gradient-primary btn-primary-action" (click)="handleSubmit()"
        [disabled]="isSubmitting">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!isSubmitting">Salvar</span>
      </button>
    </footer>
  </form>
</app-shared-drawer>